<div class="search-container" [ngClass]="[size, error ? 'error' : '']">
  @if (label) {
    <label [for]="searchId" class="search-label">{{ label }}</label>
  }

  <div class="search-input-wrapper" [ngClass]="[size, showIcon ? 'with-icon' : '']">
    @if (showIcon) {
      <lucide-icon name="Search" class="search-icon"></lucide-icon>
    }

    <p-autoComplete
      [(ngModel)]="selectedOption"
      [suggestions]="searchResults"
      [placeholder]="placeholder"
      (completeMethod)="search($event)"
      [disabled]="disabled"
      [ngClass]="[size, isDropdownOpen ? 'menu-open' : '']"
      class="custom-autocomplete"
      (onShow)="onDropdownOpen()"
      (onHide)="onDropdownClose()"
      [id]="searchId"
      field="label"
    >
      <ng-template let-item pTemplate="item">
        <span>{{ item.label }}</span>
      </ng-template>
    </p-autoComplete>
  </div>

  @if (error) {
    <div class="error-message">{{ errorMessage }}</div>
  }
</div>